import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useSiteSettings } from '../../contexts/SiteSettingsContext'
import './Navigation.css'

export default function Navigation() {
  const { user, isOwner, signOut } = useAuth()
  const { siteName } = useSiteSettings()
  const navigate = useNavigate()

  async function handleSignOut() {
    try {
      await signOut()
      navigate('/login')
    } catch (err) {
      console.error('Sign out error:', err)
    }
  }

  return (
    <header className="nav-header">
      <div className="container nav-container">
        <NavLink to="/" className="nav-brand">
          {siteName}
        </NavLink>

        <nav className="nav-links">
          <NavLink to="/lore" className="nav-link">
            Lore
          </NavLink>
          <NavLink to="/timeline" className="nav-link">
            Timeline
          </NavLink>
          <NavLink to="/albums" className="nav-link">
            Albums
          </NavLink>
          <NavLink to="/characters" className="nav-link">
            Characters
          </NavLink>
          <NavLink to="/ships" className="nav-link">
            Ships
          </NavLink>
          <NavLink to="/tools" className="nav-link">
            Tools
          </NavLink>
          <NavLink to="/spellbook" className="nav-link">
            Spellbook
          </NavLink>
          {isOwner && (
            <NavLink to="/admin" className="nav-link nav-link-admin">
              Admin
            </NavLink>
          )}
        </nav>

        <div className="nav-user">
          {user?.photoURL && (
            <img
              src={user.photoURL}
              alt={user.displayName}
              className="nav-avatar"
            />
          )}
          <span className="nav-username">{user?.displayName}</span>
          <button onClick={handleSignOut} className="nav-signout">
            Sign Out
          </button>
        </div>
      </div>
    </header>
  )
}
